import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import BulkAssemblyFragmentsTabState from 'molbio/bulk-assembly/backbone/BulkAssemblyFragmentsTabState';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import {Header2} from 'ui-library/Headers';

export default class BulkAssemblyFragmentsTabView extends BufferTabView<BulkAssemblyFragmentsTabState> {
  render(): this {
    renderToDOM(<Header2>Fragments</Header2>, this.el);
    return this;
  }

  remove(): this {
    ReactDOM.unmountComponentAtNode(this.el);
    super.remove();
    return this;
  }
}
